import z from "zod";

const zAttrRulePattern = z.object({
  type: z.literal("pattern"),
  pattern: z.string().describe("Строковое представление регулярного выражения"),
  msg: z.string().nullish(),
});
export type ZAttrRulePattern = z.infer<typeof zAttrRulePattern>;

export const zAttrRuleMin = z.object({
  type: z.literal("min"),
  minValue: z
    .number()
    .describe("значение атрибута должно быть больше или равно minValue"),
  msg: z.string().nullish(),
});

export const zAttrRuleMax = z.object({
  type: z.literal("max"),
  maxValue: z
    .number()
    .describe("значение атрибута должно быть меньше или равно maxValue"),
  msg: z.string().nullish(),
});

const zAttrRuleEmail = z.object({
  type: z.literal("email"),
  msg: z.string().nullish(),
});

const zAttrRuleFile = z.object({
  type: z.literal("file"),
});

export const zAttrRule = z.discriminatedUnion("type", [
  zAttrRulePattern,
  zAttrRuleMin,
  zAttrRuleMax,
  zAttrRuleEmail,
  zAttrRuleFile,
]);
export type ZAttrRule = z.infer<typeof zAttrRule>;
